import React, { useCallback } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import loadComponent from 'src/utils/loadMFE'
import { usePermission } from '@tomfxs/permissions-client'
import RouteContainer from 'src/components/App/RouteContainer'

const CompanyUpdateForm = React.lazy(() => loadComponent('orga', 'CompanyUpdateForm'))

export function CompanyDetailsRoute() {
    const params = useParams<{ _id: string }>()
    const navigate = useNavigate()

    const canUpdate = usePermission('orga.company.update', {
        company: params._id!,
    })
    const canDelete = usePermission('orga.company.delete', {
        company: params._id!,
    })

    const onDelete = useCallback(() => {
        navigate('/companies')
    }, [navigate])

    const onUpdate = useCallback(() => {
        navigate('/companies')
    }, [navigate])

    return (
        <RouteContainer>
            <CompanyUpdateForm _id={params._id} canDelete={canDelete} canUpdate={canUpdate} onDelete={onDelete} onUpdate={onUpdate} />
        </RouteContainer>
    )
}
